export default __webpack_public_path__ + "static/media/Tutorial-Step-4.2.b67039dd.jpg";